
import AppRoutes from "../../src/app-routes";
import HeaderMain from "../common/header";
import Footer from '../common/footer';

function RootLayout() {

    return (
        <>
            <div>
                <HeaderMain />
                <div>
                    <AppRoutes />
                </div>
                <Footer />
               
            </div>
        </>
    )
}

export default RootLayout;
